import { useQuery } from '@tanstack/react-query'
import { categoriesApi } from '@/api/endpoints/categories'
import { usePermissions } from '@/shared/hooks/use-permissions'
import { ACTIONS } from '@/shared/constants/actions'

/**
 * How many articles were sold in the last 30 days without a real product group.
 *
 * Deliberately the **sold** count, not the total: the total also contains articles that merely
 * carry a price, and a badge showing 161 is wallpaper while one showing 18 is a request. The number
 * that means "revenue is going somewhere it should not" is the sold one.
 *
 * Shared by the sidebar badge and the hint on the products list, so the two can never disagree
 * about what they are counting.
 */
export function useUnassignedCount() {
  const { can } = usePermissions()
  const allowed = can(ACTIONS.CATEGORY_VIEW)

  const query = useQuery({
    queryKey: ['categories', 'unassigned', 'count'],
    // pageSize 1: only the counts are needed, never the rows.
    queryFn: () => categoriesApi.unassigned({ pageSize: 1 }),
    enabled: allowed,
    // The badge is ambient, not a live figure — refetching it on every window focus would be noise.
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  })

  return query.data?.soldCount ?? 0
}
